import { gql } from '@apollo/client'

export const LOGIN_SA_USER = gql`
  mutation SignInSA($password: String!, $email: String!) {
    signInSA(password: $password, email: $email) {
      login
      refreshToken
      token
      client
    }
  }
`

export const UPDATE_TOKENS = gql`
  mutation updateAccessTokensSA($refreshToken: String) {
    updateAccessTokensSA(refreshToken: $refreshToken) {
      login
    }
  }
`
